/* members images */

import PaulMiller from './assets/members/PaulMiller.png';
import KevinRiley from './assets/members/KevinRiley.png';
import BrianKirkland from './assets/members/BrianKirkland.png';
import AndyNallappan from './assets/members/AndyNallappan.png';
import ManishJaiswal from './assets/members/ManishJaiswal.png';
import DrewNewman from './assets/members/DrewNewman.png';
import PaulBindel from './assets/members/PaulBindel.png';
import BrianKleber from './assets/members/BrianKleber.png';
import ToddEllerman from './assets/members/ToddEllerman.png';
import NielsFache from './assets/members/NielsFache.png';
import MattDiamond from './assets/members/MattDiamond.png';
import ThomasHarris from './assets/members/ThomasHarris.png';
import JuanJoseFigueredo from './assets/members/JuanJoseFigueredo.png';
import ValMarchevsky from './assets/members/ValMarchevsky.png';
import KumarRamanathan from './assets/members/KumarRamanathan.png';
import BradCameron from './assets/members/BradCameron.png';

import AnandBirje from './assets/members/AnandBirje.png';
import LalitWadhwa from './assets/members/LalitWadhwa.png';
import JoshuaKanter from './assets/members/JoshuaKanter.png';
import RohitNichani from './assets/members/RohitNichani.png';
import RobertoMartinez from './assets/members/RobertoMartinez.png';
import AlvaroLang from './assets/members/AlvaroLang.png';
import HenriqueOliveira from './assets/members/HenriqueOliveira.png';
import AdrianBlidarus from './assets/members/AdrianBlidarus.png';
import RodrigoVargas from './assets/members/RodrigoVargas.png';
import JessicaGamboa from './assets/members/JessicaGamboa.png';
import SameerTamboli from './assets/members/SameerTamboli.png';
import TestUser from './assets/members/TestUser.png';
import NoImg from './assets/members/no-img.png';

/* company logos */
import Encora from './assets/logos/encora-logo-black.svg';
import EncoraBlack from './assets/logos/encora-logo-black.svg';
import EncoraWhite from './assets/logos/encora-logo-white.svg';
import Aptiv from './assets/logos/Aptiv.png';
import Avid from './assets/logos/Avid.png';
import ChoiceHotels from './assets/logos/ChoiceHotels.png';
import CloudSoftwareGroup from './assets/logos/CloudSoftwareGroup.png';
import Corcentric from './assets/logos/Corcentric.png';
import DefiSolutions from './assets/logos/DefiSolutions.png';
import GoDaddy from './assets/logos/GoDaddy.png';
import Hiscox from './assets/logos/Hiscox.png';
import ImagineLearning from './assets/logos/ImagineLearning.png';
import Keysight from './assets/logos/Keysight.png';
import McAfee from './assets/logos/McAfee.png';
import Philips from './assets/logos/Philips.png';
import Scotiabank from './assets/logos/Scotiabank.png';
import UberFreight from './assets/logos/UberFreight.png';
import VelocityGlobal from './assets/logos/VelocityGlobal.png';
import Vertex from './assets/logos/Vertex.png';


/* icons */
import Edit from './assets/icons/icon-edit.png';
import Save from './assets/icons/icon-save.png';
//import Email from './assets/icons/icon-email.svg';
import Accomodation from './assets/icons/icon-accomodation.png';
import Calender from './assets/icons/icon-calender.png';
import Car from './assets/icons/icon-car.png';
import Details from './assets/icons/icon-details.png';
import DetailsDis from './assets/icons/icon-details-dis.png';
import Flight from './assets/icons/icon-flight.png';
import Location from './assets/icons/icon-location.png'

/* others images */
import LoginBg from './assets/LoginBg.jpg';
import ImgLive from './assets/img-live.png';
import ImgVirtual from './assets/img-virtual.png';
import Map from './assets/Map.png';
import EventCreated from './assets/event-created.png';

// images
import CABMembers from './assets/dashboard/img-cab_member.png';
import CABLeaders from './assets/dashboard/img-enc_leader.png';
import UpcomingEvents from './assets/dashboard/stat-upcoming_events.png';
import ManageAttendee from './assets/dashboard/img_manage_attendees.png';
import ManageEvent from './assets/dashboard/img_manage_events.png';


const Members = {
    // customers
    PaulMiller,
    KevinRiley,
    BrianKirkland,
    AndyNallappan,
    ManishJaiswal,
    DrewNewman,
    PaulBindel,
    BrianKleber,
    ToddEllerman,
    NielsFache,
    MattDiamond,
    ThomasHarris,
    JuanJoseFigueredo,
    ValMarchevsky,
    KumarRamanathan,
    BradCameron,
    
    // encorians
    AnandBirje,
    LalitWadhwa,
    JoshuaKanter,
    RohitNichani,
    RobertoMartinez,
    AlvaroLang,
    HenriqueOliveira,
    AdrianBlidarus,
    RodrigoVargas,
    JessicaGamboa,
    SameerTamboli,
    TestUser,
    NoImg
}

const Logos = {
    Encora,
    EncoraBlack,
    EncoraWhite,
    Aptiv,
    Avid,
    ChoiceHotels,
    CloudSoftwareGroup,
    Corcentric,
    DefiSolutions,
    GoDaddy,
    Hiscox,
    ImagineLearning,
    Keysight,
    McAfee,
    Philips,
    Scotiabank,
    UberFreight,
    VelocityGlobal,
    Vertex
}

const Icons = {
    Edit,
    Save,
    //Email,
    Flight,
    Accomodation,
    Calender,
    Car,
    Details,
    DetailsDis,
    Location
}

const OtherImages = {
    ImgLive,
    ImgVirtual,
    Map,
    LoginBg,
    EventCreated
}

const ImagesAll = {
    OtherImages,
    Members,
    Logos,
    Icons,
    CABLeaders,
    CABMembers,
    UpcomingEvents,
    ManageAttendee,
    ManageEvent
}

export default ImagesAll;